module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAANlBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAR2LVAAAAEXRSTlMAFHtw+/AVdon8ExcWfW13/eG/xXMAAABnSURBVEjH7dM5DoAwDETRAAlgtpD7XxYKhFjGiV0hJE/9vlzZOZvt7xsqne881Sqf9vVKrygOLy5OLywuXlTcvKB4+GLx8oUC+GwBfaaIidmMfUtcsI448FxAEz6xBOxDY+9us320DUH8EBjkLdY7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sort-up-black.png
// module id = 392
// module chunks = 30